// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateGLAccountMutation($input: UpdateGLAccountInput!) {
    updateGLAccount(input: $input) {
      glAccountEdge {
        node {
          id
          accountNumber
          name
          description
          accountType
          normalBalance
          balance
          isActive
          isSystem
          parentAccount {
            id
            name
          }
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
